import { useEffect, useState } from "react";
import { CloseIcon } from "./icons";
import { BANK_ACTION_COPY, REMARK_MAX_LENGTH } from "../data/constants";

// Defer / Cancel at this bank (remark required) and Resume (single
// confirmation) for one bank. `action` = { kind, key, bankName } or null.
export default function BankActionModal({ action, saving, onClose, onConfirm }) {
  const [remark, setRemark] = useState("");
  useEffect(() => {
    setRemark("");
  }, [action]);
  if (!action) return null;

  const copy = BANK_ACTION_COPY[action.kind];
  const missing = copy.remark && !remark.trim();
  const submit = () => {
    if (missing || saving) return;
    onConfirm(copy.remark ? remark.trim() : undefined);
  };

  return (
    <div className="overlay overlay--confirm" onClick={(e) => e.target === e.currentTarget && !saving && onClose()}>
      <div className="mail-box action-box">
        <div className="mail-box__head">
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="action-box__title">{copy.title}</div>
            <div className="action-box__sub">{action.bankName}</div>
          </div>
          <button type="button" className="sheet-box__close" onClick={onClose} disabled={saving} aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div className="mail-box__body">
          {copy.body && <div className="confirm-box__body">{copy.body}</div>}
          {copy.remark && (
            <div>
              <label className="mail-box__field-label" htmlFor="bank-action-remark">
                {copy.remarkLabel} <span className="field__req">*</span>
              </label>
              <textarea
                id="bank-action-remark"
                className="mail-box__textarea"
                rows={4}
                maxLength={REMARK_MAX_LENGTH}
                placeholder={copy.placeholder}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
              {copy.hint && <div className="action-box__hint">{copy.hint}</div>}
            </div>
          )}
          {copy.warning && <div className="action-box__warn">{copy.warning(action.bankName)}</div>}
        </div>

        <div className="mail-box__foot">
          <button type="button" className="mail-box__cancel" onClick={onClose} disabled={saving}>
            Close
          </button>
          <button
            type="button"
            className={"mail-box__send" + (copy.danger ? " mail-box__send--danger" : "")}
            onClick={submit}
            disabled={saving || missing}
          >
            {saving ? "Saving…" : copy.ok}
          </button>
        </div>
      </div>
    </div>
  );
}
